import useGetCurrentQuote from './useGetCurrentQuote';
import useIsSpainCountry from './useIsSpainCountry';
import useSuitableVehicleType from './useSuitableVehicleType';

const handlingNotAllowedForVehiclesInSpain = [
  'heavy_rigid',
  'heavy_rigid_truck',
  'trailer',
];

const useIsHandlingAllowed = () => {
  // suitable vehicle type by custom endpoint
  const suitableVehicleType = useSuitableVehicleType();
  const quote = useGetCurrentQuote();
  const quoteSuitableVehicleType = quote.vehicle_type || null;

  // suitableVehicleTypeByQuote has priority over the suitableVehicleType
  const vehicleForHandling = quoteSuitableVehicleType
    ? quoteSuitableVehicleType
    : suitableVehicleType;

  const isHandlingAllowedInSpain =
    !handlingNotAllowedForVehiclesInSpain.includes(vehicleForHandling);

  const isSpainCountry = useIsSpainCountry();

  const isHandlingAllowed = !isSpainCountry || isHandlingAllowedInSpain;

  return isHandlingAllowed;
};

export default useIsHandlingAllowed;
